<div class="modal-header">
    <h5 class="modal-title">{{ data?.title || 'Search' }}</h5>
    <button type="button" class="close" (click)="onCancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="search-container position-relative">
    <!-- Search Input -->
    <div class="search-input-group">
        <i class="pi pi-search"></i>
        <input type="text" class="form-control" [formControl]="searchControl" 
               placeholder="Type to search..." autofocus>
    </div>

    <!-- Filters Section -->
    <div class="filter-section" *ngIf="data?.filterShow && filterCol.length" [formGroup]="filterForm">
        <div class="filter-item" *ngFor="let f of filterCol">
            <label>{{ removeUnderscore(f.tblName) }}</label>
            <select class="custom-select" [formControlName]="f.tblName" (change)="searchData(searchControl.value)">
                <option value="">All {{ removeUnderscore(f.tblName) }}</option>
                <option *ngFor="let opt of FORM_SUPPORT_DATA[f.tblName]" [value]="opt.id">
                    {{ opt.name || opt.label || opt.title || opt[f.tblName + 'Name'] || opt[f.tblName + '_name'] || opt.dName || opt.deName
                    }}
                </option>
            </select>
            <div *ngIf="DATA_LOADING[f.tblName]" class="text-mini text-muted mt-1">
                <i class="pi pi-spin pi-spinner mr-1"></i> Loading...
            </div>
        </div>
    </div>

    <!-- Results List -->
    <div class="results-list" *ngIf="resultData.length && !loading">
        <div class="result-item" *ngFor="let res of resultData" (click)="onConfirm(res)">
            <div class="avatar-box">
                <img *ngIf="res.avatarPic" [src]="res.avatarPic" alt="Avatar">
                <div *ngIf="!res.avatarPic" class="avatar-placeholder">
                    {{ (res.avatarTxt | slice:0:1) || '?' }}
                </div>
            </div>
            
            <div class="item-info">
                <span class="item-title" [innerHTML]="res.detail"></span>
                <span class="item-meta text-muted" [innerHTML]="res.mutedText"></span>
            </div>

            <div class="item-actions">
                <span class="top-text" [innerHTML]="res.topEndText"></span>
                <span class="bottom-text" [innerHTML]="res.bottomEndText"></span>
            </div>
        </div>
    </div>

    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="loading">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!resultData.length && !loading && searchControl.value">
        <i class="pi pi-search-minus"></i>
        <p>No results found for "{{ searchControl.value }}"</p>
    </div>
    
    <div class="empty-state" *ngIf="!searchControl.value && !loading">
        <i class="pi pi-info-circle"></i>
        <p>Enter search terms to find what you're looking for</p>
    </div>
</div>